import { deleteCookie } from 'cookies-next';

import { BasketViewModel } from '@api/index';
import {
  advancePaymentStorageKey,
  activePaymentMethodStorageKey,
  PAYMENT_CHANNEL,
  PAYMENT_REQUEST_ID,
  PAYMENT_COOKIE_OPTIONS,
} from '@constants/constants';

// The advance payment option (as currently defined by the business rule) is supported only and only if
// the basket contains a single hotel and no other item type (flight, tour, etc...)
export const checkAdvancePaymentSupport = (basket?: BasketViewModel) => {
  if (!basket) return {};
  const { hotels = [], flights = [], tours = [] } = basket;
  const isSupported =
    hotels.length === 1 && flights.length === 0 && tours.length === 0;
  const advancePaymentDetail = hotels[0]?.advancePaymentDetail;
  return { isSupported, advancePaymentDetail };
};

export const getAdvancePaymentRate = (basket?: BasketViewModel) => {
  return basket?.hotels?.[0]?.advancePaymentDetail?.rate ?? 0;
};

/**
 * cookie storage item name for payment page
 */
export const clearPaymentCookieStorage = () => {
  if (typeof window !== 'undefined') {
    deleteCookie(PAYMENT_CHANNEL, PAYMENT_COOKIE_OPTIONS);
    deleteCookie(PAYMENT_REQUEST_ID, PAYMENT_COOKIE_OPTIONS);
  }
};

export const clearBasketStorage = (withCookies = false) => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('basketDetail');
    localStorage.removeItem('basketId');
    localStorage.removeItem('paymentRequestToken');
    localStorage.removeItem('advanceDeadline');
    localStorage.removeItem('activePaymentMethod');
    localStorage.removeItem(advancePaymentStorageKey);
    localStorage.removeItem(activePaymentMethodStorageKey);
    localStorage.removeItem('guests');

    if (withCookies) {
      clearPaymentCookieStorage();
    }
  }
};
